import React from 'react';
import WOW from 'wowjs'

import EstateMinComponent from './estateMinComponent'


class EstateList extends React.PureComponent {


    componentDidMount(){
        new WOW.WOW().init();
    }

    render() {
        return (
            <div className="col-lg-8 col-md-8 col-xs-12 col-md-push-4">
                <div className="clearfix"></div>
                {
                    this.props.estates.length > 0 ?
                        this.props.estates.map((estate, idx) => {
                            return <EstateMinComponent key={idx} estate={estate} />
                        }) : <div className="no-estates">"No results"</div>
                }
            </div>
        )
    }
}


export default EstateList;
